export const colors = {
  peach: '#FAE9CA',
  black: '#010101',
  red: '#990200'
}



// WEBPACK FOOTER //
// ./src/style.js